<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="false"
    :region-selection="true"
    :province-selection="true"
    use-expansion
  >
    <template #expansion="{ data }">
      <div
        class="query__expansion-container"
      >
        <QueryExpansionField
          field-name="Descripción"
          :field-value="data.description"
        />
      </div>
    </template>
  </QueryView>
</template>

<script setup>
import {ref} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryExpansionField from '@/components/query-expansion-field/QueryExpansionField';
import QueryTableConfig from '../query-table.view-config.js';
import {PROTECTED_AREAS_SCHEMA} from './query-protected-areas-table.view-config.js';
import {searchProtectedArea} from '@/api/protected-area/protected-area.api.js';
import {
  searchProtectedAreaHtml,
  searchProtectedAreaPdf,
  getProtectedAreaPdf,
} from '@/api/protected-area/protected-area.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
// #endregion

// #region Functions
async function goProtectedArea({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 10;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}

function protectedAreaToText({name, province, region, description}) {
  const res = `
    Nombre: ${name}
    Provincia: ${province}
    Comunidad Autónoma: ${region}
    Descripción: ${description}
    `;
  return res;
}
async function printProtectedArea(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(
      data.id,
      'Espacio protegido - ' + data.name,
      getProtectedAreaPdf,
    );
  }
}
async function htmlProtectedAreaQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery(
      'Informe Espacios protegidos',
      searchProtectedAreaHtml,
      'html',
    );
  }
}
async function printProtectedAreaQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Espacios protegidos', searchProtectedAreaPdf);
  }
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchProtectedArea,
  recordToText: protectedAreaToText,
  copyClipboard: copy,
  htmlQuery: htmlProtectedAreaQuery,
  printQuery: printProtectedAreaQuery,
  printRecord: printProtectedArea,
  centerMap: goProtectedArea,
  schema: PROTECTED_AREAS_SCHEMA,
});

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped></style>
